import { useCampuses } from '@/store/org/hooks';
import type { Campus, CampusRoleKey } from '@/shared/types/campus';
import { UserSet } from './user';

export function CampusName({ id }: { id: string }) {
  const { lookup } = useCampuses();
  const campus = lookup[id];

  return <div>{campus?.data.name || ''}</div>;
}

export function CampusRoleAssignees({
  role,
  item,
  render = 'item',
}: {
  role: CampusRoleKey;
  item: Campus;
  render?: 'text' | 'item';
}) {
  const ids = item.data.roles?.[role] || [];

  return <UserSet ids={ids} render={render} />;
}
